import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextLayoutMultiLine from '@contexts/layoutMultiLine'
import { LayoutItemProps } from '@widgets/LayoutItem/types'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'
import { computeFlex } from '@widgets/Teaser/utils'
import { ComputedTeaserFlex } from '@widgets/Teaser/types'

interface StyledLayoutItemProps {
  flexOptions: ComputedTeaserFlex
}

const StyledLayoutItem = styled.div<StyledLayoutItemProps>`
  ${({ flexOptions }) => css`
    && {
      &:empty {
        display: none;
      }

      min-width: 0;

      ${desktopCSS(css`
        grid-column: span ${flexOptions.desktop};
      `)}

      ${tabletCSS(css`
        grid-column: span ${flexOptions.tablet};
      `)}

    ${mobileCSS(css`
        grid-column: span ${flexOptions.mobile};

        > aside {
          &:not(:first-child) {
            margin-top: 20px;
          }
        }
      `)}
    }
  `}
`

const { LayoutMultiLineContext } = contextLayoutMultiLine

const LayoutItem: FunctionComponent<LayoutItemProps> = ({
  children,
  options = {},
}) => {
  const { flex } = options

  const layoutMultilineContext = useContext(LayoutMultiLineContext)

  const hasParentGrid = !!layoutMultilineContext?.grid

  const flexOptions = computeFlex({ parentFlex: flex ?? '6', hasParentGrid })

  return (
    <StyledLayoutItem flexOptions={flexOptions}>{children}</StyledLayoutItem>
  )
}

export default LayoutItem
